import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import IconDiagnosis from 'components/icons/IconDiagnosis';

const styles = () => ({
  root: {
    height: 330,
  },
  iconDiagnosis: {
    width: 105,
    height: 105,
  },
});

const DiagnosesTableEmpty = ({ classes }) => (
  <Grid
    className={classes.root}
    container
    direction="column"
    justify="center"
    alignItems="center"
    spacing={24}
  >
    <Grid item>
      <IconDiagnosis className={classes.iconDiagnosis} />
    </Grid>
    <Grid item>
      <Typography variant="subheading" color="secondary">
        Unfortunately, there are no such Diagnoses
      </Typography>
    </Grid>
  </Grid>
);

DiagnosesTableEmpty.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    iconDiagnosis: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(DiagnosesTableEmpty);



// WEBPACK FOOTER //
// ./src/components/settings/DiagnosesTable/DiagnosesTableEmpty.js